import makeStyles from "@mui/styles/makeStyles";

import { getBrandCustom } from "../../../../../util/getCustomColor";

const styles = makeStyles(() => ({
  generalWrapper: {
    padding: "24px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    paddingBottom: "16px",
    borderBottom: "1px solid #E4E7EC",
  },
  title: {
    font: "600 24px/32px Inter",
    color: getBrandCustom("primaryColor", "#38cfc4"),
    margin: 0,
  },
  headerActions: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },
  filterButton: {
    minWidth: "100px",
  },
  createButton: {
    minWidth: "120px",
  },
}));

export default styles;
